import { Icon, Stack } from "@fluentui/react";

import { DefaultCardTitle } from "../../DisplayContractInfo/styles";

import { IInvoiceInfos } from "./interfaces";
import { InvoiceMonthly } from "./InvoiceMonthly";
import { InvoicePlans } from "./InvoicePlans";
import { InvoiceSetup } from "./InvoiceSetup";
import {
  InvoiceContainer,
  Container,
  ItemsContainer,
  InvoiceSection
} from "./styles";

import { PaymentMethodType } from "@/common/types/PaymentMethod.types";

interface InvoiceProps {
  invoiceInfos: IInvoiceInfos;
  paymentMethodName: string;
  paymentMethodType?: PaymentMethodType;
  showInvoicePlans?: boolean;
  isInsidePanel?: boolean;
  isTagService?: boolean;
}

export function Invoice({
  invoiceInfos,
  paymentMethodName,
  paymentMethodType,
  showInvoicePlans = false,
  isInsidePanel,
  isTagService = false
}: InvoiceProps): JSX.Element {
  const setupInstallments = invoiceInfos?.setup.installments;

  return (
    <Stack
      style={{
        width: `${isInsidePanel ? "100%" : "70%"}`,
        marginTop: "10px",
        flex: "1"
      }}
      data-clarity-mask
    >
      <DefaultCardTitle>
        <Icon iconName="Money" style={{ marginRight: 10 }} />
        Resumo dos Pagamentos
      </DefaultCardTitle>
      <InvoiceContainer>
        <Container>
          <ItemsContainer>
            {showInvoicePlans && <InvoicePlans plans={invoiceInfos?.plans} />}

            <InvoiceSetup
              setup={invoiceInfos?.setup}
              title="Valor a Pagar"
              isTagService={isTagService}
              paymentMethodType={paymentMethodType}
            />

            <InvoiceSection>
              {!isTagService && (
                <InvoiceMonthly
                  installments={invoiceInfos?.installments}
                  title={"Fatura - Valor Mensal"}
                />
              )}

              {setupInstallments?.length > 0 && (
                <InvoiceMonthly
                  installments={setupInstallments}
                  title={`Pagamento: ${paymentMethodName} (${setupInstallments?.length}x)`}
                  installmentText="ª Parcela"
                />
              )}
            </InvoiceSection>
          </ItemsContainer>
        </Container>
      </InvoiceContainer>
    </Stack>
  );
}
